// extracted by mini-css-extract-plugin
module.exports = {"box":"u-checkbox_box__2XUctTA1","root":"u-checkbox__2XUctTA1","empty":"u-checkbox_empty__2XUctTA1"};